module.exports = __webpack_public_path__ + "img/paper-icon.ff11272a.png";